import { queryClient } from '@/components/providers/QueryClientProvider/queryClient'
import { useAnalyticsFiltersStore } from '../features/Analytics/stores/useAnalyticsFiltersStore/useAnalyticsFiltersStore'
import useAnalyticsStore from '../features/Analytics/stores/useAnalyticsStore/useAnalyticsStore'
import { useBillingFiltersStore } from '../features/BillingPayments/stores/useBillingFiltersStore/useBillingFiltersStore'
import useAuthStore from '../stores/useAuthStore/useAuthStore'
import { useDashboardUsageAndCostFiltersStore } from '../stores/useDashboardUsageAndCostFiltersStore/useDashboardUsageAndCostFiltersStore'

export const logoutCleanup = () => {
    const clearSession = useAuthStore.getState().clearSession
    const { resetActiveDataSets } = useAnalyticsStore.getState().usageAndCost
    const { resetActiveFilters: resetAnalyticsFilters } =
        useAnalyticsFiltersStore.getState()
    const { resetActiveFilters: resetBillingFilters } =
        useBillingFiltersStore.getState()
    const { resetActiveFilters: resetDashboardFilters } =
        useDashboardUsageAndCostFiltersStore.getState()

    resetAnalyticsFilters()
    resetBillingFilters()
    resetDashboardFilters()
    resetActiveDataSets()
    clearSession()
    queryClient.clear()
}
